import get from "lodash/get";

import moment from "moment";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Modal from "../modal-new";
import DateInput from "../inputs/date-input";
import { DATE_FORMATS } from "../../constants";
import { getValidDates } from "../../utils/date-helpers";

const { DATE_PICKER_FORMAT, DATE_DAY_FORMAT } = DATE_FORMATS;

const CalendarMoveWorkoutModal = (props, { locals }) => {
  const { activeExercises, query } = locals;
  const [validDates, setValidDates] = useState(getValidDates(activeExercises));

  const dateValidator = (pickerDate) => {
    const formattedPickerDate = moment(pickerDate).format(DATE_DAY_FORMAT);

    return validDates[formattedPickerDate];
  };

  const activeDay = moment.utc(query.day, DATE_DAY_FORMAT).startOf("day");
  const exportDate = moment
    .utc(get(query, "day"), DATE_DAY_FORMAT)
    .format(DATE_PICKER_FORMAT);

  return (
    <form
      action={`/actions/exercise/move-day?proxyAthlete=${query.athlete}&reqSource=calendar`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="type" value="move" />
      <input type="hidden" name="from" value={activeDay.toJSON()} />

      <Modal
        className="Move-Workout export-workout"
        title="Move Workout"
        toClear={["day"]}
      >
        <div className="body">
          <label htmlFor="">Today's Date</label>
          <p className="s1">{activeDay.format(DATE_PICKER_FORMAT)}</p>

          <label htmlFor="to" className="mt-6">
            Move workout to
          </label>
          <DateInput
            name="to"
            defaultValue={exportDate}
            dateValidator={(date) => dateValidator(date, locals)}
            placeholder="Select a date"
          />
        </div>

        <footer>
          <a
            role="button"
            data-button-type="text-white"
            data-action="cancel"
            href="/actions/refresh?modal[type]=&day="
          >
            Cancel
          </a>
          <button role="button" data-button-type="primary" type="submit">
            Move
          </button>
        </footer>
      </Modal>
    </form>
  );
};

CalendarMoveWorkoutModal.contextTypes = { locals: PropTypes.object };

export default CalendarMoveWorkoutModal;
